module.exports = "data:text/x-markdown;base64,VGhlIGdvYWwgb2YgdGhpcyBsZXZlbCBpcyB0byB3aXRoZHJhdyBhbGwgdGhlIGV0aGVycyBmcm9tIHRoZSBhZGRyZXNzIG9mIHRoZSBgRmFrZUZpYm9uYWNjaUJhbmtgIGluc3RhbmNlLgoKJm5ic3A7ClRoaW5ncyB0aGF0IG1pZ2h0IGhlbHA6CiogU3R1ZHkgZGVsZWdhdGVjYWxsCg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/fakeFibonacci.md
// module id = 1371
// module chunks = 0